import { Component, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { GeneralButtonComponent } from '../../components';
import type { IFilterAngularComp } from 'ag-grid-angular';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { NgOptimizedImage } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-ag-grid-text-filter',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatListModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    TranslatePipe,
    GeneralButtonComponent,
  ],
  templateUrl: './ag-grid-text-filter.component.html',
  styleUrls: ['./ag-grid-text-filter.component.scss'],
})
export class AgGridTextFilterComponent implements IFilterAngularComp {
  private params!: IFilterParams;
  private appliedValue = '';
  value = signal('');

  agInit(params: IFilterParams): void {
    this.params = params;
  }

  isFilterActive(): boolean {
    return !!this.appliedValue;
  }

  getModel() {
    return this.appliedValue ? { filter: this.appliedValue, filterType: 'text', type: 'contains' } : null;
  }

  setModel(model: { filter: string; filterType?: string; type?: string }): void {
    this.appliedValue = model?.filter ?? '';
    this.value.set(this.appliedValue);
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    if (!this.appliedValue) return true;

    const node = params.node;
    const cellValue = this.params.getValue(node);

    if (cellValue == null) return false;

    return String(cellValue).toLowerCase().includes(this.appliedValue.toLowerCase());
  }

  setSearch(event: Event): void {
    this.value.set((event.target as HTMLInputElement).value);
  }

  applyFilter(): void {
    this.appliedValue = this.value().trim();
    this.params.filterChangedCallback();
    this.params.api?.hidePopupMenu();
  }

  resetFilter(): void {
    this.appliedValue = '';
    this.value.set('');
    this.params.filterChangedCallback();
  }
}
